import React from 'react';
import PropTypes from 'prop-types';

import { AppBar } from '@material-ui/core';
import { useMediaQuery } from '@material-ui/core';
// import { useTheme } from '@material-ui/core/styles';
import useStyles from './style';
import { breakpoints } from '../../../../styles/themes/vad/constants';

const StickyBar = ({ className = '', children, mobileBottomSticky = true }) => {
  // const theme = useTheme();
  // const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const isMobile = useMediaQuery(`(max-width:${breakpoints.values.md}px)`);
  useStyles({ mobileBottomSticky });

  return (
    <AppBar
      component="div"
      color="secondary"
      className={`${className} ${isMobile &&
        mobileBottomSticky &&
        'mobile-sticky-bottom'}`}
      id="stickyBar"
      position="static"
      elevation={0}
    >
      {children}
    </AppBar>
  );
};

StickyBar.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
};

export default StickyBar;
